import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
export default (html, name) => {
  var clone = hiddenClone(html);
  var pdf = new jsPDF();

  html2canvas(clone, {userCORS: true}).then((canvas) => {
        document.body.removeChild(clone);
        if(canvas.height >= 1800){
          pdf.addImage(canvas, 'png', 10, 10, 190, 270);
        }
        else {
          pdf.addImage(canvas, 'png', 10, 10, 190, canvas.height*0.15);
        }
        pdf.save(name + '.pdf')
      })
}
var hiddenClone = (element) => {
  // Create clone of element
  var clone = element.cloneNode(true);


  // Replace each image with a text. In the future images should come from our server and show. Problem is because of CORS
  var images = clone.getElementsByTagName('img');
  Array.from(images).forEach((image) => {
    var parent = image.parentElement;
    var text = document.createElement("em");
    text.innerHTML = "**Imagen reemplazada por texto, vea la ficha en la plataforma para poder ver el documento completo**";
    parent.replaceChild(text, image);
  });

  // Position element relatively within the
  // body but still out of the viewport
  document.body.appendChild(clone);
  var style = clone.style;
  style.position = 'relative';
  style.top = 0;
  style.left = 0;
  return clone;
}



// WEBPACK FOOTER //
// ./src/lib/PdfGenerator.js